import React from "react";
import { Typography } from "@material-ui/core";

const ReportTerminationInfo = () => {
  return (
    <>
      <Typography variant={"h2"}>Report Termination</Typography>
      <Typography variant={"h6"}>
        If you continue, the following will happen immediately:
        <ul>
          <li>They will be prevented from making transfers in DailyPay</li>
          <li>Their available balance will stop accruing earnings</li>
        </ul>
      </Typography>
    </>
  );
};

export default ReportTerminationInfo;
